<template>
	<transition name="modal" enter-active-class="animated fadeIn" appear>
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div class="modal-body m-0 moveListModal-body">
						<slot name="body">
							<div class="row mx-0 mb-3">
								<div class="col-12 pr-0 pl-1">
									<div class="input-style input-style-2 input-required has-icon m-0">
										<i class="input-icon fa fa-calendar color-orange-dark"></i>
										<date-picker type="date" v-model="date" :auto-submit="true" format="jYYYY/jMM/jDD" element="filterDT" />
										<input class="form-control ltr" type="text" id="filterDT" placeholder="تاریخ" v-model="date" />

									</div>
								</div>
								<div class="col-12 p-0 mt-2">
									<div class="search-box bg-magenta1-light rounded-sm">
										<i class="fa fa-search"></i>
										<input type="text" class="border-0 pr-4" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
									</div>
								</div>
							</div>
							<div class="moveListModal-body-itemRow">
								<div :class="{'bg-magenta1-light' : selectedCheckListId==task.checkListId}" class="card card-style mb-2 mx-0 shadow-0" @click.prevent="setAsSelected(task)" v-for="task in CheckListModalList" :key="task.checkListId">
									<div class="list-group list-custom-small list-icon-0">

										<div class="list-group-div p-2">
											<div>
												<i class="fa fa-calendar text-warning"></i>
												<span class="text-muted d-inline-block text-left ltr">{{task.checkListDate}}</span>
											</div>
											<div class="d-flex justify-content-between">
												<div>
													<i class="fa fa-check color-red1-dark"></i>
													<span class="font-weight-bold">{{task.subject}}</span>
												</div>
											</div>
										</div>


									</div>
								</div>

							</div>
						</slot>
					</div>
					<div class="modal-footer py-1 px-2">
						<slot name="footer">
							<button :disabled="Loading" class="btn btn-xxs rounded-s bg-green2-light" @click="selectItem">
								<i class="fa fa-check ml-2"></i>
								ثبت
							</button>
							<button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
								<i class="fa fa-times ml-2"></i>
								بستن
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>



</template>
<script>
	import DatePicker from 'vue3-persian-datetime-picker';

	export default {
		components: {
			DatePicker,
		},
		props: ['checkListFolderId','checkListId'],
		data() {
			return {
				page: 0,
				filterId: null,
				searchKey: null,
				date: null,
				Loading: false,
				errorMsg: null,
				readOnly: false,
				selectedCheckListId: null
			};
		},
		computed: {
			CheckListModalList() {
				return this.$store.getters.GetCheckListModalList;
			},
		},
		mounted() {
			this.getFilterCheckListModalList();
			//document.getElementById("subjectFolder").focus();
		},
		methods: {
			getFilterCheckListModalList() {

				this.page++;
				console.log(this.page);
				this.$store.dispatch("GetCheckListModalListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					searchKey: this.searchKey,
					date: this.date
				});
			},
			filterList() {
				this.page = 0;
				this.getFilterCheckListModalList();

			},
			selectItem() {
				this.Loading = true;
				this.$emit('selectItem', this.selectedCheckListId);
			},
			setAsSelected(item) {
				this.selectedCheckListId = item.checkListId;
			}
		}

	};
</script>
<style>
	.modal-mask {
		position: fixed;
		z-index: 1;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 300px;
		margin: 0px auto;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
	}

	.modal-body {
		margin: 20px 0;
		line-height: 1;
	}

	.modal-default-button {
		float: right;
	}


	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

		.modal-enter .modal-container,
		.modal-leave-active .modal-container {
			-webkit-transform: scale(2);
			transform: scale(2);
		}
</style>
